import {
  LOAD_WORKING_HOUR,
  SHOW_WORKING_HOUR,
  CREATE_WORKING_HOUR,
  UPDATE_WORKING_HOUR,
  DELETE_WORKING_HOUR,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    name: "",
    company_id: [],
    plantzone_id: 0,
    schedule_type: "close_plant",
    time_type: "sametime",
    all_user_plant: "N",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    remark: "",
    plant_ids: [],
    weekday : [0,1,2,3,4,5,6],
    is_spacial : "N",
    is_active: "Y"

  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_WORKING_HOUR.REQUEST:
    case SHOW_WORKING_HOUR.REQUEST:
    case CREATE_WORKING_HOUR.REQUEST:
    case UPDATE_WORKING_HOUR.REQUEST:
    case DELETE_WORKING_HOUR.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false
      };

    case LOAD_WORKING_HOUR.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_WORKING_HOUR.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_WORKING_HOUR.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_WORKING_HOUR.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_WORKING_HOUR.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true
      };
    case LOAD_WORKING_HOUR.FAILURE:
    case SHOW_WORKING_HOUR.FAILURE:
    case CREATE_WORKING_HOUR.FAILURE:
    case UPDATE_WORKING_HOUR.FAILURE:
    case DELETE_WORKING_HOUR.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false
      };

    default:
      return state;
  }
};
